// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 7443) return "wp-content/assets/js/pages/attraction/7443.js";
	if (chunkId === 4656) return "wp-content/assets/js/pages/attraction/4656.js";
	// return url for filenames based on template
	return undefined;
};